import './styles/global.css';
import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth.js';
import { setOnUnauthorized, setTokenGetter } from './lib/api.js';
import { ToastProvider } from './ui/toast.js';
import { App } from './App.js';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 15_000, refetchOnWindowFocus: false } },
});

/** Bridges the auth session into the decoupled API client (token + 401 handling). */
function ApiBridge() {
  const { session, signOut } = useAuth();
  useEffect(() => {
    setTokenGetter(() => session?.token ?? null);
    setOnUnauthorized(() => signOut());
  }, [session, signOut]);
  return null;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ToastProvider>
          <BrowserRouter>
            <ApiBridge />
            <App />
          </BrowserRouter>
        </ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
